/**
 * ページごとのSNSボタン、シェアリンクの設定
 */
class _snsShare {
  constructor() {}

  once() {
    const elAll = document.querySelectorAll('.block-js-share a');
    this.hashTag = '';
    this.meta = this.getMeta();

    if (!elAll) return;
    elAll.forEach((el, index) => {
      const classList = el.classList;
      if (classList.contains('c-btnSns--tw')) {
        /** twitter */
        el.setAttribute('href', 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(`${this.meta.title} ${this.meta.url} ${this.meta.hashtag}`));
        el.setAttribute('target', '_blank');
      } else if (classList.contains('c-btnSns--fb')) {
        /** facebook */
        el.setAttribute('href', 'https://www.facebook.com/share.php?u=' + this.meta.url);
        el.setAttribute('target', '_blank');
      } else if (classList.contains('c-btnSns--line')) {
        /** line */
        el.setAttribute('href', "https://line.me/R/msg/text/?" + encodeURIComponent(`${this.meta.title} ${this.meta.url} ${this.meta.hashtag}`) +'%0D%0A'+ this.meta.url);
        el.setAttribute('target', '_blank');
      } else if (classList.contains('c-btnSns--in')) {
        /** linkedin */
        el.setAttribute('href', "https://www.linkedin.com/sharing/share-offsite/?url=" + this.meta.url);
        el.setAttribute('target', '_blank');
      }
    });
  }

  getMeta() {
    const ogTitle = document.querySelector("meta[property='og:title']");
    const ogDescription = document.querySelector("meta[property='og:description']");
    const ogUrl = document.querySelector("meta[property='og:url']");

    return {
      title: ogTitle ? ogTitle.getAttribute('content') : '',
      description: ogDescription ? ogDescription.getAttribute('content') : '',
      url: ogUrl ? ogUrl.getAttribute('content') : location.href,
      hashtag: this.hashTag
    }
  }

  reset() {
    delete this.hashTag;
    delete this.meta;
  }
}

const snsShare = new _snsShare();

export default snsShare;